import { createAsyncThunk } from "@reduxjs/toolkit";
import { getTotalCertificationDAshboardAPI, getTotalClientsDashboardAPI, getTotalOtherUsersAPI } from "../../apiConfig/apiCall";

export const getTotalClients = createAsyncThunk('getTotalClients', async () => {
    const response = await getTotalClientsDashboardAPI();
    return response.data;
});

export const getTotalUsers = createAsyncThunk('getTotalUsers', async (ROLE) => {
    const response = await getTotalOtherUsersAPI(ROLE);
    return response.data;
});

export const getTotalClientAdmin = createAsyncThunk('getTotalClientAdmin', async (ROLE) => {
    const response = await getTotalOtherUsersAPI(ROLE);
    return response.data;
});

export const getTotalClientUsers = createAsyncThunk('getTotalClientUsers', async (ROLE) => {
    const response = await getTotalOtherUsersAPI(ROLE);
    return response.data;
});

export const getTotalClientAuditors = createAsyncThunk('getTotalClientAuditors', async (ROLE) => {
    const response = await getTotalOtherUsersAPI(ROLE);
    return response.data;
});

export const getTotalCertifications = createAsyncThunk('getTotalCertifications', async () => {
    const response = await getTotalCertificationDAshboardAPI();
    return response.data;
});